import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { TopSectionComponent } from './about/top-section/top-section.component';
import { MessageFromComponent } from './about/message-from/message-from.component';
import { MissionSectionComponent } from './about/mission-section/mission-section.component';
import { ExperienceSectionComponent } from './about/experience-section/experience-section.component';
import { LeadershipSectionComponent } from './about/leadership-section/leadership-section.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { CoreValuesComponent } from './about/core-values/core-values.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { ContactButtonsComponent } from './contact-us/contact-buttons/contact-buttons.component';
import { HaveQuestionsFormComponent } from './contact-us/have-questions-form/have-questions-form.component';
import { AccessibilityComponent } from './accessibility/accessibility.component';
import { AccessibilityContentComponent } from './accessibility/accessibility-content/accessibility-content.component';
import { PrivacyStatementComponent } from './privacy-statement/privacy-statement.component';
import { PrivacyContentComponent } from './privacy-statement/privacy-content/privacy-content.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { TermsContentComponent } from './terms-conditions/terms-content/terms-content.component';
import { SolutionsComponent } from './solutions/solutions.component';
import { SolutionsTitleComponent } from './solutions/solutions-title/solutions-title.component';
import { IndustrySectionComponent } from './solutions/industry-section/industry-section.component';
import { SystemSectionComponent } from './solutions/system-section/system-section.component';
import { SolutionsSectionComponent } from './solutions/solutions-section/solutions-section.component';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { environment } from "src/environments/environment";


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutComponent,
    TopSectionComponent,
    MessageFromComponent,
    MissionSectionComponent,
    ExperienceSectionComponent,
    LeadershipSectionComponent,
    HeaderComponent,
    FooterComponent,
    CoreValuesComponent,
    ContactUsComponent,
    ContactButtonsComponent,
    HaveQuestionsFormComponent,
    AccessibilityComponent,
    AccessibilityContentComponent,
    PrivacyStatementComponent,
    PrivacyContentComponent,
    TermsConditionsComponent,
    TermsContentComponent,
    SolutionsComponent,
    SolutionsTitleComponent,
    IndustrySectionComponent,
    SystemSectionComponent,
    SolutionsSectionComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    RecaptchaV3Module,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.ReCaptcha3PublicKey }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
